import React from "react";
import { ThirdwebProvider } from "@thirdweb-dev/react";

// Define the Cronos chain configuration
const cronosChain = {
  chainId: 25, // Cronos mainnet chain ID
  rpc: ["https://evm.cronos.org"], // RPC URL for Cronos
  name: "Cronos Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Cronos",
    symbol: "CRO", // Native currency symbol
  },
  slug: "cronos", // Unique identifier for the chain
  testnet: false, // Set to true for testnets
};

// Add your Thirdweb API Key
const clientId = "deafa5547a9c185113a3b6a30f2bdc00"; // Replace this with your Thirdweb API Key

const ThirdwebWrapper = ({ children }) => {
  return (
    <ThirdwebProvider supportedChains={[cronosChain]} activeChain={cronosChain} clientId={clientId}>
      {children}
    </ThirdwebProvider>
  );
};

export default ThirdwebWrapper;
